import React from 'react';
import { TimelineElement as TimelineType } from '@/types';
import TimelineElement from './TimelineElement';

type Props = {
  timeline_elements: TimelineType[];
};

function Timeline(props: Props) {
  const { timeline_elements: timelineElements } = props;

  return (
    <div>
      <div className="timeline__wrapper">
        {timelineElements.map(timelineElement => (
          <TimelineElement
            key={timelineElement.title}
            title={timelineElement.title}
            text={timelineElement.text}
          />
        ))}
      </div>
    </div>
  );
}

export default Timeline;
